module.exports = __webpack_public_path__ + "static/media/redeDisplayYoutuber.f078bf87.png";